function attachKlaviyoTracking() {
  const btn = document.querySelector('button.add-to-cart-button[name="add"]');
  if (!btn || btn._klaviyoAttached) return;

  btn._klaviyoAttached = true;

  btn.addEventListener('click', function() {
    setTimeout(function() {
      const title = document.querySelector('a.link')?.innerText?.trim();
      const priceEl = [...document.querySelectorAll('.price')].find(e => e.innerText?.trim().length > 0);
      const price = priceEl?.innerText?.trim();
      const image = document.querySelector('.product__media img, .product-media img, [class*="product"] img')?.src;
      const form = btn.closest('form');
      const variantId = form?.querySelector('[name="id"]')?.value;

      if (typeof klaviyo !== 'undefined' && title) {
        klaviyo.track('Added to Cart', {
          AddedItemProductName: title,
          AddedItemProductID: variantId || '',
          AddedItemImageURL: image || '',
          AddedItemURL: window.location.href,
          AddedItemPrice: price || '',
          CheckoutURL: window.location.origin + '/checkout'
        });
        console.log('Klaviyo: Added to Cart disparado para', title);
      }
    }, 800);
  });
}

const observer = new MutationObserver(function() {
  attachKlaviyoTracking();
});

observer.observe(document.body, { childList: true, subtree: true });

attachKlaviyoTracking();